export const SortOrder = {
  ASCEND: 'ASCEND',
  DESCEND: 'DESCEND',
} as const;

export const CaseSensitive = {
  SENSITIVE: 'SENSITIVE',
  INSENSITIVE: 'INSENSITIVE',
} as const;

type SortOrderValueType = typeof SortOrder[keyof typeof SortOrder];
type CaseSensitiveValueType = typeof CaseSensitive[keyof typeof CaseSensitive];

export const sortStrings = (
  string1: string = '',
  string2: string = '',
  sortOrder: SortOrderValueType = SortOrder.ASCEND,
  sensitive: CaseSensitiveValueType = CaseSensitive.INSENSITIVE
) => {
  const isCaseSensitive = sensitive === CaseSensitive.SENSITIVE;
  const processedString1 = isCaseSensitive ? string1 : string1.toLowerCase();
  const processedString2 = isCaseSensitive ? string2 : string2.toLowerCase();

  if (processedString1 === processedString2) return 0;

  if (sortOrder === SortOrder.ASCEND) return processedString1 > processedString2 ? 1 : -1;

  return processedString1 > processedString2 ? -1 : 1;
};

export const sortDateStrings = (
  dateString1?: string,
  dateString2?: string,
  sortOrder: SortOrderValueType = SortOrder.ASCEND
) => {
  if (!dateString1 && !dateString2) return 0;

  // If only one is missing, treat undefined as "biggest" (no date is usually 'in the future')
  if (!dateString1) return sortOrder === SortOrder.ASCEND ? 1 : -1;
  if (!dateString2) return sortOrder === SortOrder.ASCEND ? -1 : 1;

  const epoch1 = new Date(dateString1).getTime();
  const epoch2 = new Date(dateString2).getTime();

  if (isNaN(epoch1) && isNaN(epoch2)) return 0;
  if (isNaN(epoch1)) return sortOrder === SortOrder.ASCEND ? 1 : -1;
  if (isNaN(epoch2)) return sortOrder === SortOrder.ASCEND ? -1 : 1;

  if (sortOrder === SortOrder.ASCEND) return epoch1 - epoch2;

  return epoch2 - epoch1;
};
